const LetterState = {
  GREEN: 1,
  YELLOW: 2,
  GREY: 3,
};
Object.freeze(LetterState);
export default LetterState;
